<div class="popup-content">
    <div class="image-notice">
        <img src="../../../../assets/images/icons/bell.svg" alt="">
    </div>
    <p [innerHTML]="title"></p>
</div>